import { render, staticRenderFns } from "./StampDetails.vue?vue&type=template&id=b0c6e7b2&scoped=true&"
import script from "./StampDetails.vue?vue&type=script&lang=js&"
export * from "./StampDetails.vue?vue&type=script&lang=js&"
import style0 from "./StampDetails.vue?vue&type=style&index=0&id=b0c6e7b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c6e7b2",
  null
  
)

export default component.exports